import { useUser } from "contexts";
import { UserRoles } from "data/roles";
import PropTypes from "prop-types";
import { useTogglePublic } from "services/stories";
import { ToggleButton } from "../StoryPreview";
import { MoreItem } from "./MoreButton";

function VisibilityButton({ mode, onClose, story }) {
  const { hasPermission, hasRole } = useUser();
  const { isPublic, loading, togglePublic } = useTogglePublic(
    story._id,
    story.isPublic
  );

  if (mode === "menu") {
    return (
      <MoreItem
        icon="visibility"
        onClick={() => {
          togglePublic();
          onClose();
        }}
      >
        {isPublic ? "Ocultar" : "Publicar"}
      </MoreItem>
    );
  }

  return (
    <ToggleButton
      hidden={
        !hasRole(UserRoles.ADMIN) ||
        (!story.isOwner && !hasPermission("stories:edit__privacy"))
      }
      icon={isPublic ? "public" : "lock"}
      label={isPublic ? "Público" : "Privado"}
      loading={loading}
      onClick={togglePublic}
    />
  );
}

VisibilityButton.propTypes = {
  mode: PropTypes.oneOf(["button", "menu"]),
  onClose: PropTypes.func,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    isOwner: PropTypes.bool,
    isPublic: PropTypes.bool,
  }).isRequired,
};

export default VisibilityButton;
